import { formatInAppTz, parseAppWallClock } from '@/utils/spain-time';

/**
 * `10:00:00 - 11:00:00` for a CNMC window, its only consumer. CNMC stores its
 * datetimes as Madrid wall clock with no offset, so they are read as such
 * rather than in the viewer's clock.
 */
export function getHoursRange(startDatetime: string, endDatetime: string) {
  const startTime = formatInAppTz(parseAppWallClock(startDatetime), 'HH:mm:ss');
  const endTime = formatInAppTz(parseAppWallClock(endDatetime), 'HH:mm:ss');

  return `${startTime} - ${endTime}`;
}
